import React, { useState,useEffect } from 'react';
import TermsConditions from '../components/TermsConditions';
import PrepaidTermsConditions from '../components/PrepaidTermsConditions'
import { requestData } from '../js/api.js'
import BookReview from './BookReview.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { setBookingId } from "../redux/data.js";
import { calculateDaysBetween,calculatePrice } from '../js/function.js'
import AlertWindow from '../components/Alert'

function Book() {
  const dispatch = useDispatch();
  const [orderID,setOrderId] = useState('')
  const searchData = useSelector((state) => state.data.searchData);
  const selectedExtraOptions = useSelector((state) => state.data.selectedExtraOptions);
  const days = calculateDaysBetween(searchData.startDate, searchData.startTime, searchData.endDate, searchData.endTime)
  const initData = useSelector((state) => state.data.initData);
  const [relocationFee, setRelocationFee] = useState('0')
  const [youngdriverFee, setYoungdriverFee] = useState('0')
  const [olddriverFee, setOlddriverFee] = useState('0')
  const basePrice = calculatePrice(searchData.vehiclePrice,initData,searchData,days,selectedExtraOptions,relocationFee,youngdriverFee,olddriverFee)
  const [openAlert, setOpenAlert] = useState(false)
  const alertMessage = useState('Please filled in all information')
  const [bookingTerms, setBookingTerms] = useState(false);
  const [prepaidBooking, setPrepaidBooking] = useState(false);
  const [bond, setBond] = useState(false);
  const allAgreed = bookingTerms && prepaidBooking && bond;
  const [customerInfo, setCustomerInfo] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phonenumber: '',
  })

  const [loading, setLoading] = useState(false)

  const getRelocationFee = async () => {
    try {
      let data = await requestData('GET', 'relocation');
      if (data.success) {
        setRelocationFee(data.price)
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  const getYoungAge = async () => {
    try {
      let data = await requestData('GET', 'youngdrivesurcharge');
      if (data.success) {
        setYoungdriverFee(data.price)
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  const getOldAge = async () => {
    try {
      let data = await requestData('GET', 'olddrivesurcharge');
      if (data.success) {
        setOlddriverFee(data.price)
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  useEffect(() => {
    getRelocationFee()
    getYoungAge()
    getOldAge()
  }, [])

  const paynow = async () => {
    if(loading===true){
      return 
    }
    const allFilled = Object.values(customerInfo).every(value => value.trim() !== '');
    if (allFilled) {
      setLoading(true)
      try {
        // let price=(basePrice * 1.1).toFixed(2)
        let price=(basePrice).toFixed(2)
        const res = await requestData('POST', 'create-checkout-session',
          {
            title: 'carrental', price:price, searchData: searchData, selectedExtraOptions: selectedExtraOptions,
            customerInfo: customerInfo,
            lastname:customerInfo.lastname,
            orderID:orderID
          });
        if(res.success){
          setOrderId(res.orderId)
          window.open(res.url, '_blank');
        }else{
          alert(res.error)
        }
      } catch (error) {
        console.error('Error:', error);
      }
      finally{
        setLoading(false)
      }
    } else {
      setOpenAlert(true)
    }
  }

  const handleChangeInfo = (event, key) => {
    setCustomerInfo(prevState => ({
      ...prevState,
      [key]: event.target.value
    }));
  }

  const handleBack = () => {
    dispatch(setBookingId('extra'))
  }
  
  return (
    <div>

      <BookReview disabledMoreInfo={true} relocationFee={relocationFee} youngdriverFee={youngdriverFee} olddriverFee={olddriverFee}/>

      <div class="pb-6 pt-2 text-start border-b-2 border-gray-200 px-2">
        <h2 class="text-2xl font-semibold mb-4">Renter Information</h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="flex flex-col">
            <label for="firstName" class="text-sm font-medium text-gray-600">First Name <span class="text-red-500">*</span></label>
            <input value={customerInfo.firstname} onChange={(event) => handleChangeInfo(event, 'firstname')} type="text" id="firstName" placeholder="e.g. John..." class="mt-1 p-3 border border-gray-300 rounded-lg text-sm text-gray-600 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
          </div>

          <div class="flex flex-col">
            <label for="lastName" class="text-sm font-medium text-gray-600">Last Name <span class="text-red-500">*</span></label>
            <input value={customerInfo.lastname} onChange={(event) => handleChangeInfo(event, 'lastname')} type="text" id="lastName" placeholder="e.g. Smith..." class="mt-1 p-3 border border-gray-300 rounded-lg text-sm text-gray-600 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
          </div>

          <div class="flex flex-col md:col-span-2">
            <label for="email" class="text-sm font-medium text-gray-600">Email <span class="text-red-500">*</span></label>
            <input value={customerInfo.email} onChange={(event) => handleChangeInfo(event, 'email')} type="email" id="email" placeholder="e.g. johnsmith@mail.com" class="mt-1 p-3 border border-gray-300 rounded-lg text-sm text-gray-600 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
          </div>

          <div class="flex flex-col md:col-span-2">
            <label for="phone" class="text-sm font-medium text-gray-600">Phone Number <span class="text-red-500">*</span></label>
            {/* <div class="flex items-center"> */}
            {/* <select id="countryCode" class="p-3 border border-gray-300 rounded-lg text-sm text-gray-600 focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
              <option value="+61">+61 (AU)</option>
            </select> */}
            <input value={customerInfo.phonenumber} onChange={(event) => handleChangeInfo(event, 'phonenumber')} type="tel" id="phone" placeholder="e.g. +61 7723 123..." class="flex-1 mt-1 p-3 border border-gray-300 rounded-lg text-sm text-gray-600 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 " />
            {/* </div> */}
          </div>
        </div>
      </div>

      <div class="pb-6 pt-2 text-start text-start px-2">
        <h2 class="text-2xl font-semibold mb-2">Complete booking</h2>
        <div class="px-4">
          <p class="text-sm font-medium text-gray-600 mb-2">What you need at pick-up:</p>
          <ul class="list-disc list-inside text-sm text-gray-600 space-y-1 mb-2">
            <li>A valid <strong>physical driver's license</strong> and <strong>physical ID</strong>.</li>
            <li>A valid <strong>physical Visa</strong> or <strong>MasterCard</strong> credit card in the driver's name.</li>
          </ul>
        </div>
        <div className="p-4">
          <div className="space-y-3">
            <div className='flex'>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="w-5 h-5 text-blue-600 accent-blue-600" checked={bookingTerms} onChange={(e) => setBookingTerms(e.target.checked)} />
                <div className='flex'>
                  I agree to the&nbsp;
                </div>
              </label>
              <TermsConditions />
            </div>

            <div className='flex'>
              <label className="flex items-center space-x-2 inline-block">
                <input type="checkbox" className="w-5 h-5 text-blue-600 accent-blue-600" checked={prepaidBooking} onChange={(e) => setPrepaidBooking(e.target.checked)} />
                <div className='flex'>
                  I agree to the&nbsp;
                </div>
              </label>
              <PrepaidTermsConditions />
            </div>

            <div className='flex'>
              <label className="flex items-center space-x-2 inline-block">
                <input type="checkbox" className="w-5 h-5 text-blue-600 accent-blue-600" checked={bond} onChange={(e) => setBond(e.target.checked)} />
                <div className='flex'>
                  I accpet bond (A$800–$2,500 refundable, depending on the vehicle type);
                </div>
              </label>
            </div>

            <label className="flex items-center space-x-2">
              <input type="checkbox" className="w-5 h-5 text-blue-600 accent-blue-600" defaultChecked />
              <span>Subscribe to our newsletter to receive exclusive offers!</span>
            </label>

          </div>

          <div className="mt-6">
            <button className="px-6 py-2 bg-primary text-white font-semibold rounded-md hover:bg-primary/80 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary" disabled={!allAgreed} onClick={paynow}>
              Make Payment
              {loading && <div className='p-8 relative items-center'>
                <div role="status" class="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                  <svg aria-hidden="true" class="w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                  <span class="sr-only">Loading...</span>
                </div>
              </div>}
            </button>
          </div>
        </div>
      </div>

      <div className='flex justify-between mx-4'>
        <button
          onClick={handleBack}
        >
          &larr;&nbsp;Previous
        </button>
        <div></div>
      </div>

      <AlertWindow setOpenAlert={setOpenAlert} openAlert={openAlert} message={alertMessage} />
    </div>
  );
}

export default Book;